import { Component, OnInit, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { FidelityService } from 'src/app/services/api/fidelity/fidelity.service';
import { MediaObserver } from '@angular/flex-layout';
import {CssService} from "../../../../services/css-service";

@Component({
  selector: 'app-fidelity-slider-product',
  templateUrl: './fidelity-slider-product.component.html',
  styleUrls: ['./fidelity-slider-product.component.css']
})
export class FidelitySliderProductComponent implements OnInit {

  @ViewChild('slider', { static: true }) slider: ElementRef|any;

  @Input() merchant: any;
  @Input() client: any;
  @Input() available: boolean|any;

  fidelityProducts: any[] = [];

  arrowLeft: boolean = false;
  arrowRight: boolean|any;
  loader: boolean = true;

  constructor(
    public cssService: CssService,
    private fidelityApi: FidelityService
  ) {
  }

  ngOnInit() { }

  ngAfterContentInit() {

    this.fidelityApi.$_getFidelityProducts(this.merchant.id_webshop, this.client.fidelity_points_clients_dash, this.available).then(products => {

      this.loader = false;
      this.fidelityProducts = this.parseProducts(products);
    })
  }

  parseProducts(products: any[]) {
    let parsedProducts:any = [];
    if(products && products.length>0){
    products.map(prod => {

      if (prod.image.length > 0) {
        const ratio = this.client.fidelity_points / prod.fidelity_points;
        const percent = (ratio > 1) ? 100 : (ratio === 0) ? 0 : ratio * 100;
        prod.percent_points = (Math.round(percent * 100) / 100)
        parsedProducts.push(prod);
      }
    })}
    return parsedProducts;
  }
}
